import { Tooltip, Typography, theme } from 'antd';
import { TextProps } from 'antd/es/typography/Text';
import { FC, ReactNode, memo } from 'react';
import { Clipboard, ClipboardCheck } from 'react-bootstrap-icons';

interface Props extends Omit<TextProps, 'copyable' | 'ellipsis'> {
  textToCopy: string;
  children?: ReactNode;
  iconSize?: number;
  maxLength?: number;
}

const truncateText = (text: string, maxLength: number = 10): string => {
  if (text.length <= maxLength) return text;
  const prefixLength = 10;
  const suffixLength = 10;
  return `${text.slice(0, prefixLength)}...${text.slice(-suffixLength)}`;
};

export const CopyableText: FC<Props> = memo(({ children, textToCopy, iconSize = 12, ...props }) => {
  const { token } = theme.useToken();

  const { style, ...otherProps } = props;

  const displayText = typeof children === 'string' ? truncateText(children, 30) : children;

  return (
    <Tooltip
      placement="left"
      title={typeof children === 'string' ? (children.length > 30 ? textToCopy : undefined) : undefined}
      styles={{ root: { minWidth: 'max-content' } }}
    >
      <Typography.Paragraph
        {...otherProps}
        // ellipsis={{
        //   // rows: 1,
        //   tooltip: { placement: 'top', overlayStyle: { minWidth: 'max-content' }, children: textToCopy },
        // }}
        style={{
          ...style,
          color: 'inherit',
          fontSize: 'inherit',
          display: 'inline-flex',
          alignItems: 'center',
          margin: 0,
          maxWidth: '100%',
        }}
        copyable={{
          text: textToCopy,
          icon: [
            <Clipboard size={iconSize} key="copy-icon" />,
            <ClipboardCheck fill={token.colorSuccess} size={iconSize} key="copied-icon" />,
          ],
          tooltips: ['Скопіювати', 'Скопійовано!'],
        }}
      >
        {displayText}
      </Typography.Paragraph>
    </Tooltip>
  );
});
